export default (id, trackingData = {}) => {
  let calls = 0
  let initialized = false

  const doInit = () => {
    if (initialized || !window.pendo) {
      return false
    }

    const { product, releaseStage } = ENV
    let prefix = product === 'orgamax' ? 'OM' : 'MB'
    if (releaseStage === 'prelive') {
      prefix = `${prefix}-PRELIVE`
    } else if (releaseStage === 'development') {
      prefix = `${prefix}-DEV`
    } else if (releaseStage === 'local') {
      prefix = `${prefix}-LOCAL`
    }
    const pendoInitialized = typeof window.pendo?.isReady === 'function' && window.pendo.isReady()

    const keysToUse = Object.keys(trackingData).filter(key => key.includes('subscriptionEnd') || key.includes('planId'))
    const subscriptionProps = keysToUse.reduce((result, key) => {
      result[key] = trackingData[key]
      return result
    }, {})

    const pendoData = {
      visitor: {
        id: `${prefix}${trackingData.userId}`,
        email: trackingData.userEmail,
        role: trackingData.role,
        ...(prefix === 'MB' && { buhlKontoId: trackingData.userGlobalId }),
      },
      account: {
        id: `${prefix}${trackingData.tenantId}`,
        ownerUserId: trackingData.ownerUserId,
        ownerEmail: trackingData.ownerEmail,
        isDesktopTenant: trackingData.isDesktopTenant,
        isDesktopLogin: trackingData.isDesktopLogin,
        ...(prefix === 'MB' && { ownerBuhlKontoId: trackingData.ownerGlobalId }),
        createdAt: trackingData.createdAt,
        registrationClient: trackingData.registrationClient,
        ...subscriptionProps,
        onboardingFinished: trackingData.onboardingFinished,
        onboardingFinishedAt: trackingData.onboardingFinishedAt,
        abtest: trackingData.abTest,
      },
    }
    if (pendoInitialized) {
      window.pendo.identify(pendoData)
    } else {
      window.pendo.initialize(pendoData)
    }
    window.dispatchEvent(new CustomEvent('pendo-ready'))
    initialized = true
    return true
  }

  const init = () => {
    if (initialized || calls >= 10) {
      return
    }

    if (window.pendo) {
      doInit()
      return
    }

    // we do not know when pendo is ready > use timeout to test init several times
    calls++
    setTimeout(init, 1000 * calls)
  }

  // Listen for Pendo script to load (handles delayed execution due to consent manager blocking)
  const onPendoScriptLoaded = () => {
    window.removeEventListener('pendo-script-loaded', onPendoScriptLoaded)
    if (!initialized && window.pendo) {
      doInit()
    }
  }
  window.addEventListener('pendo-script-loaded', onPendoScriptLoaded)

  init()
}
